import { z } from 'zod';
import { BaseRequestSchema, UuidSchema } from './primitives.ts';

export const ListHistorySchema = BaseRequestSchema.extend({
  action: z.literal('list_history'),
  cursor: z.string().optional(),
  maxResults: z.number().int().min(1).max(500).default(100),
});

export const GetSignatureSchema = BaseRequestSchema.extend({
  action: z.literal('get_signature'),
});

export const RefreshSignatureSchema = BaseRequestSchema.extend({
  action: z.literal('refresh_signature'),
});

export const RefreshSendAsSchema = BaseRequestSchema.extend({
  action: z.literal('refresh_send_as'),
});

export const GetCapabilitiesSchema = BaseRequestSchema.extend({
  action: z.literal('get_capabilities'),
}).omit({ accountId: true });

/**
 * Unsubscribe-affordance gate for one email: returns the computed
 * eligibility verdict + available methods, never the raw header URIs
 * (List-Unsubscribe values embed per-recipient tokens and stay
 * server-side). When the row's `list_headers_checked_at` is unset the
 * handler lazily fetches the list headers from the provider and persists
 * them before answering.
 *
 * `emailId` is the `email_metadata` row id. Like `fetch_message_body`,
 * the owning account is derived server-side from
 * `email_metadata.account_id`, so `accountId` is omitted from the wire
 * schema — a caller cannot smuggle a sibling account id.
 */
export const GetUnsubscribeInfoSchema = BaseRequestSchema.extend({
  action: z.literal('get_unsubscribe_info'),
  emailId: UuidSchema,
}).omit({ accountId: true });
